import { log } from "../../utils/log";
import { overrideFetch } from "./interceptors/fetch";

export const initAuthCore = (): void => {
  log('AuthCore initialized');
  overrideFetch();
};
